import { render, staticRenderFns } from "./SingleRecord.vue?vue&type=template&id=03e2b3d5&scoped=true&"
import script from "./SingleRecord.vue?vue&type=script&lang=js&"
export * from "./SingleRecord.vue?vue&type=script&lang=js&"
import style0 from "./SingleRecord.vue?vue&type=style&index=0&id=03e2b3d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2b3d5",
  null
  
)

export default component.exports